export default "__VITE_ASSET__6PSvYC0D__"